module.exports = __webpack_public_path__ + "logo.2be69f808de5f25592d5.png";


//////////////////
// WEBPACK FOOTER
// /Users/elliot/code/abc-angular/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles